import { render, staticRenderFns } from "./EmployeeBranchesTable.vue?vue&type=template&id=2d19e6a3&"
import script from "./EmployeeBranchesTable.vue?vue&type=script&lang=js&"
export * from "./EmployeeBranchesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports